import { useMemo } from 'react';
import { useDebounce } from 'usehooks-ts';
import api from 'lib/trpcClient';
import { InvestorValidationLabels } from 'further-ui/labels';

type Props = {
  firstName: string | undefined;
  lastName: string | undefined;
  dob: string | undefined;
  firmId: string | undefined;
  ignoreInvestorId?: string;
};

export const useDuplicateIndividualInvestorWarning = ({
  firstName,
  lastName,
  dob,
  firmId,
  ignoreInvestorId,
}: Props) => {
  const debouncedInvestor = useDebounce(
    {
      firstName: firstName ?? '',
      lastName: lastName ?? '',
      dob: dob ?? '',
    },
    300,
  );

  const enabled =
    !!debouncedInvestor.firstName &&
    !!debouncedInvestor.lastName &&
    !!debouncedInvestor.dob &&
    !!firmId;

  const { data } = api.investor.checkIndividualInvestorUnique.useQuery(
    {
      firstName: debouncedInvestor.firstName,
      lastName: debouncedInvestor.lastName,
      dob: debouncedInvestor.dob,
      firmId: firmId ?? '',
      ignoreInvestorId,
    },
    {
      enabled,
    },
  );

  return useMemo(
    () => ({
      hasWarning: enabled && data === false,
      message: InvestorValidationLabels.IndividualAccountNotUnique,
    }),
    [data, enabled],
  );
};
